<app-authorized-header [customClass]="'flex justify-content-center'" [headerCustomClass]="'text-primary'"
  [header]="greeting"
[subHeader]="'Let’s make SARA Plus work for you! Let us know if you need any help, our support team is happy to help.'"></app-authorized-header>
<div class="flex justify-content-center">
  @if (welcomeInfo && user) {
    <div class="w-full lg:w-10 xl:w-8 flex gap-3 flex-column">
      <div>
        <div class="grid">
          <div class="col">
            @if (orderEntryButtonEnabled) {
              <p-button icon="pi pi-plus" [size]="'large'" label="START NEW ORDER" styleClass="w-full"
                [rounded]="true" (onClick)="onStartNewOrderClicked()" />
            }
          </div>
        </div>
      </div>
      <div>
        @if (welcomeInfo.ATTUIDDetails && welcomeInfo.ATTUIDDetails.Message?.length > 0) {
          <p-card
            styleClass="border-1 border-primary border-round-lg shadow-none"
            [style]="{'background-color': '#FEF8E4'}">
            <div class="flex align-items-start gap-3">
              <i class="pi pi-exclamation-triangle text-yellow-500 mt-1"></i>
              <div class="flex-1">
                <div class="text-xl font-semibold mb-2 text-900">
                  Add your AT&T UID to keep selling AT&T
                </div>
                <p class="m-0 mb-3 text-700 line-height-3">
                  {{welcomeInfo.ATTUIDDetails.Message}}
                </p>
                <!-- Dynamic days calculation, enabled if DaysLeft is available -->
                <!-- <div class="mb-3 text-700">
                <span class="days-badge">{{welcomeInfo.ATTUIDDetails.DaysLeft}} days</span>
                until you will lose the ability to process orders.
              </div> -->
              <p-button label="Get an AT&T UID" styleClass="p-button-outlined p-button-primary">
              </p-button>
            </div>
          </div>
        </p-card>
      }
    </div>
    @if (welcomeInfo.NewFeatures && welcomeInfo.NewFeatures.length > 0) {
      <div>
        <p-card styleClass="border-1 border-primary border-round-lg shadow-none">
          <ng-template pTemplate="title">
            <div class="p-card-title text-primary"> New Features</div>
          </ng-template>
          <ul>
            @for (item of welcomeInfo.NewFeatures; track item) {
              <div class="mb-2">
                <li>{{item.Description}}</li>
              </div>
            }
          </ul>
        </p-card>
      </div>
    }
    @if (welcomeInfo.OutageNotifications && welcomeInfo.OutageNotifications.length > 0) {
      <div>
        <p-card styleClass="border-1 border-primary border-round-lg shadow-none">
          <ng-template pTemplate="title">
            <div class="p-card-title text-primary">Outage Notifications</div>
          </ng-template>
          <ul>
            @for (item of welcomeInfo.OutageNotifications; track item) {
              <div class="mb-2">
                <li>{{item.Description}}</li>
              </div>
            }
          </ul>
        </p-card>
      </div>
    }
  </div>
}
</div>